define('gumbo-js-client-lib/forms/liveData/DefenseForm',{
	catcher: null,
	center: null,
	first: null,
	left: null,
	pitcher: null,
	right: null,
	second: null,
	shortstop: null,
	third: null,
	teamID: null,
	team: null
});
